const getPriorProductsFingerprint = ({
  adverts: { priorProductsFingerprint },
}) => priorProductsFingerprint;

export default getPriorProductsFingerprint;
